import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 py-3" aria-label="主导航">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 flex-shrink-0 group"
            aria-label="黑料吃瓜网首页"
          >
            <span className="text-xl font-bold text-primary-500 font-heading tracking-wide group-hover:text-primary-600 transition-colors">
              🍉 黑料吃瓜网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-500 hover:bg-primary-50"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label={mobileMenuOpen ? "关闭菜单" : "打开菜单"}
          >
            <i className={`w-5 h-5 flex items-center justify-center text-foreground-700 ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden mt-2 pb-2 animate-in slide-in-from-top-2 duration-200">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === "/"
                    ? "bg-primary-100 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                🏠 首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? "bg-primary-100 text-primary-600"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === "/about"
                    ? "bg-primary-100 text-primary-600"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                📖 关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}